/**
 * @fileoverview Module for `src/partners/lib/hooks.js`.
 */

import { useEffect, useMemo } from 'react';
import { useRouteMatch } from 'react-router-dom';

/**
 * Reads the partner slug from route params and persists it in session storage.
 *
 * @returns {string} Normalized partner slug.
 */
function usePartnerSlug() {
  const { params } = useRouteMatch();
  const partnerSlug = useMemo(
    () => params.partner?.toLowerCase() || '',
    [params.partner],
  );
  useEffect(
    () => {
      if (partnerSlug) {
        sessionStorage.setItem('partner', partnerSlug);
      }
    },
    [partnerSlug],
  );
  return partnerSlug;
}

// eslint-disable-next-line import/prefer-default-export
export { usePartnerSlug };
